// NB: We pull out the subcomponents individually here to avoid exporting cascader internal only subcomponent exports, such as the ones prepended by "Internal"
import {
  NoOptionsMessage,
  SearchWrapper,
  SearchOptionsList,
  SearchOption,
  SearchOptionLabel,
  SearchOptionPath,
  LeafOption,
  SubmenuOption,
  MenuWrapper,
  SubmenuWrapper,
  SubmenuHeader,
  SubmenuGroupWrapper,
  SubmenuGroupHeader,
  SubmenuGroupItemList,
  SubmenuGroupDivider,
  Container,
  Control,
  Input,
  Placeholder,
  ClearIndicator,
  DropdownIndicator,
  IndicatorSeparator,
  IndicatorsContainer,
  SelectedValueContainer,
  SingleSelectedValue,
  PositioningContainer,
} from './subcomponents';

export {
  computeCascaderSuggestionFlags,
  subtreeContainsSuggestionLeaf,
} from './assistance';
export {
  flattenOptions as flattenCascaderOptions,
  isSubmenu as isCascaderSubmenu,
} from './util';
export {
  baseSearchFilter,
  baseSearchSort,
} from './hooks/useCascaderComputedValues';
export { EMPTY_SUBMENU } from './consts';

export { Cascader } from './Cascader';
export type { CascaderFixtureSuggestionOption } from './cascaderFixtureSuggestionTypes';
export * from './types';

export const CascaderComponents = {
  NoOptionsMessage,
  SearchWrapper,
  SearchOptionsList,
  SearchOption,
  LeafOption,
  SubmenuOption,
  MenuWrapper,
  SubmenuWrapper,
  SubmenuHeader,
  SubmenuGroupWrapper,
  SubmenuGroupHeader,
  SubmenuGroupItemList,
  SubmenuGroupDivider,
  Container,
  Control,
  Input,
  Placeholder,
  ClearIndicator,
  DropdownIndicator,
  IndicatorSeparator,
  IndicatorsContainer,
  SelectedValueContainer,
  SingleSelectedValue,
  PositioningContainer,
};

export const CascaderUtilityComponents = {
  SearchOptionLabel,
  SearchOptionPath,
};
